import { DocumentData, FirestoreDataConverter } from 'firebase/firestore'

export const AUDIT_ACTION_TYPES = {
  VIEWED: 'viewed',
  EDITED: 'edited',
  SIGNED: 'signed',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  SENT: 'sent',
  CREATED: 'created'
}

export class ProposalAudit {
  id: string
  proposalId: string
  projectId: string
  action: string
  userId: string
  userEmail: string
  userName: string
  ipAddress: string
  userAgent: string
  details: Record<string, any>
  timestamp: Date

  constructor() {
    this.id = ''
    this.proposalId = ''
    this.projectId = ''
    this.action = ''
    this.userId = ''
    this.userEmail = ''
    this.userName = ''
    this.ipAddress = ''
    this.userAgent = ''
    this.details = {}
    this.timestamp = new Date()
  }
}

export const proposalAuditConverter: FirestoreDataConverter<ProposalAudit, DocumentData> = {
  toFirestore: (audit: ProposalAudit) => {
    audit.timestamp = audit.timestamp ? new Date(audit.timestamp) : new Date()
    return Object.assign({}, JSON.parse(JSON.stringify(audit)))
  },

  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options)
    data.timestamp = (typeof data.timestamp === 'object') ? data.timestamp.toDate() : data.timestamp
    return Object.assign(new ProposalAudit(), JSON.parse(JSON.stringify(data))) as ProposalAudit
  }
} 